<template>
  <div
    style="height: 200px;width: 100%;background-color: rgba(0, 0, 0, 0.3);"
    class="title-backgroud"
  >
    <img :src="require(`../assets/${title_img_src}`)" />
  </div>
</template>
<script>
export default {
  name: 'title-backgroud',
  props: ['title_img_src']
}
</script>
<style scoped>
img {
  height: 100px;
  margin-top: 50px;
}
</style>


// WEBPACK FOOTER //
// src/components/Header-Title.vue